import dir1 from "../images/teachers/RealTeachers/dir1.jpg";
import dir2 from "../images/teachers/RealTeachers/dir2.jpg";
import dir3 from "../images/teachers/RealTeachers/dir3.jpg";
import dir4 from "../images/teachers/RealTeachers/dir4.jpg";

import chf1 from "../images/teachers/RealTeachers/chf1.jpg";
import chf2 from "../images/teachers/RealTeachers/chf2.jpg";
import chf3 from "../images/teachers/RealTeachers/chf3.jpg";
import chf4 from "../images/teachers/RealTeachers/chf4.jpg";
import chf5 from "../images/teachers/RealTeachers/chf5.jpg";

import ens1 from "../images/teachers/RealTeachers/ens1.jpg";
import ens2 from "../images/teachers/RealTeachers/ens2.jpg";
import ens3 from "../images/teachers/RealTeachers/ens3.jpg";
import ens4 from "../images/teachers/RealTeachers/ens4.jpg";
import ens5 from "../images/teachers/RealTeachers/ens5.jpg";
import ens6 from "../images/teachers/RealTeachers/ens6.jpg";
import ens7 from "../images/teachers/RealTeachers/ens7.jpg";
import ens8 from "../images/teachers/RealTeachers/ens8.jpg";
import ens9 from "../images/teachers/RealTeachers/ens9.jpg";
import ens10 from "../images/teachers/RealTeachers/ens10.jpg";
import ens11 from "../images/teachers/RealTeachers/ens11.jpg";
import ens12 from "../images/teachers/RealTeachers/ens12.jpg";
import ens13 from "../images/teachers/RealTeachers/ens13.jpg";
import ens14 from "../images/teachers/RealTeachers/ens14.jpg";
import ens15 from "../images/teachers/RealTeachers/ens15.jpg";
import ens16 from "../images/teachers/RealTeachers/ens16.jpg";
import ens17 from "../images/teachers/RealTeachers/ens17.jpg";
import ens18 from "../images/teachers/RealTeachers/ens18.jpg";

import exemple from "../images/teachers/teachers_v2/exemple.png";

export const direction = [
  {
    img: dir1,
    link_title: "Lotfi_CHERIF",
    title: "Lotfi CHERIF",
    isDirector: true,
    Biographie: [],
    Qualifications: [],
    Domaines: [],
    Cours: [],
    role: "Directeur General Adjoint",
  },
  {
    img: dir2,
    link_title: "Ahmed_CHERIF",
    title: "Ahmed CHERIF",
    isDirector: false,
    Biographie: ["B.A UC Berkeley", "M.A Sciences Po Paris"],
    Qualifications: [
      "Aitamurto, T., Boin, J-B., Chen, K., Cherif, A. and Shridhar, S. The Impact of Augmented Reality on Art Engagement: Liking, Learning - and a Distraction. Virtual, Augmented and Mixed Reality: Applications in Health, Cultural Heritage, and Industry.",
      "Civic CrowdAnalytics: Making sense of crowdsourced civic input with big data tools",
      "The Power of Citizens’ Voices in Democracy — Examining the Impact of Civic Input on Crowdsourced Policymaking. 20th International Research Society",
    ],
    Domaines: [],
    Cours: [],
    role: "Directeur General Adjoint",
  },

  {
    img: dir3,
    link_title: "Khaled_GHEDIRA",
    title: "Khaled GHEDIRA",
    isDirector: false,
    Biographie: [
      "Ingénieur ENSEEIHT (France)",
      "Ingénieur ENSIMAG (France)",
      "HdR en Informatique de l’ENSI",
      "Docteur en Intelligence Artificielle de l’ENSAE (France)",
    ],
    Qualifications: [
      "The r-dominance: a new dominance relation for interactive evolutionary multicriteria decision making",
      "Ant colony optimization for multi-objective optimization problems",
      "Discussion and review on evolving data streams and concept drift adapting",
      "Ant algorithm for the multidimensional knapsack problem",
      "Preference incorporation in evolutionary multiobjective optimization: A survey of the state-of-the-art",
      "A novel chemical reaction optimization for the distributed permutation flowshop scheduling problem with makespan criterion",
      "Searching for knee regions of the Pareto front using mobile reference points",
      "Rule-based credit risk assessment model using multi-objective evolutionary algorithms",
    ],
    Domaines: [],
    Cours: [],
    role: "Directeur Scientifique et Pédagogique",
  },
  {
    img: dir4,
    link_title: "Fatma_HIZAOUI",
    title: "Fatma HIZAOUI",
    isDirector: false,
    Biographie: [
      "Architecte",
      "Docteur en Sciences et Ingénieries Architecturales",
      "Spécialiste en Morphologie spatiale et morphométrie de la lumière",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: ["Atelier d’architecture "],
    role: "Directrice de l’Ecole Polytechnique",
  },
];

export const chef_depart = [
  {
    img: chf3,
    link_title: "Mohamed_Amine_BELLALOUNA",
    title: "Mohamed Amine BELLALOUNA",
    isDirector: false,
    Biographie: ["Doctorat en sciences et technologies du Design"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Analyse et interprétation du paysage architectural du Kef",
      "Initiation à la méthodologie du projet",
      "Voyage d'études et projet d'application",
    ],
    role: "Chef du departement Architecture",
  },
  {
    img: chf1,
    link_title: "Feriel_BEN MUSTPHA",
    title: "Feriel BEN MUSTPHA",
    isDirector: false,
    Biographie: ["Doctorat en Gestion Management"],
    Qualifications: [
      "the links between leaders, values, Islam and Management",
      "The International Journal of Arts and Sciences (IJAS) Conference, June 2011, Harvard",
      "“Succession in Tunisian family firms”University of Marrakech, Marocco, May 2011",
    ],
    Domaines: [],
    Cours: [
      "Séminaire métiers",
      "Initiation aux business games",
      "Stratégie de l'entreprise",
      "Management Stratégique",
      "Projet intégré",
    ],
    role: "Cheffe du departement Business",
  },
  {
    img: chf2,
    link_title: "Ines_TRIKI",
    title: "Ines TRIKI",
    isDirector: false,
    Biographie: ["Doctorat en Droit Privé"],
    Qualifications: [],
    Domaines: [],
    Cours: ["Droit des successions", "Droit bancaire"],
    role: "Cheffe du departement Droit",
  },
  {
    img: chf4,
    link_title: "Malek_AMMOUS",
    title: "Malek AMMOUS",
    isDirector: false,
    Biographie: ["Doctorat en Génie électrique"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Fondements de l'IA",
      "Algorithmique et structures de données I",
      "Algorithmique et structures de données II",
    ],
    role: "Cheffe du departement Informatique",
  },
  {
    img: chf5,
    link_title: "Amel_BEN_AYED",
    title: "Amel BEN AYED",
    isDirector: false,
    Biographie: ["Doctorat en sciences et techniques des arts."],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Méthodologie de projet appliqué I",
      "Méthodologie de projet appliqué II",
    ],
    role: "Cheffe du departement Design",
  },
];

export const teachers = [
  {
    img: ens1,
    link_title: "Imen_CHAOUCH",
    title: "Imen CHAOUCH",
    isDirector: false,
    Biographie: [
      "Diplôme d’études approfondies en Systèmes d’Information",
      "Certificat « Digital Coach ». IHE Academy & Uptitude",
      "Certificat « Professional Scrum Master 1 »",
      "Certificat « Marketing digital » Medianet",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "SCRUM MASTER",
      "Communication Digitale",
      "Management de projet I",
      "Séminaire métiers II",
      "Management de projet I",
      "Gestion des prix et des produits",
      "Principes de gestion II",
      "Projet intégré I",
      "Projet intégré II",
      "Marketing électronique",
      "Technique de communication",
    ],
    role: "Enseignante Marketing",
  },
  {
    img: ens2,
    link_title: "Zohra_BEN MANSOUR",
    title: "Zohra BEN MANSOUR",
    isDirector: false,
    Biographie: ["Mastère en Droit Privé : sciences criminelles"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Procédures pénales",
      "Organisation administrative",
      "Droit civil : Théorie générale du Droit subjectif",
      "Théorie générale des obligations : responsabilité civile",
      "Droit pénal",
      "Droit des successions",
      "Propriété industrielle",
    ],
    role: "Enseignante Droit",
  },
  {
    img: ens3,
    link_title: "Rym_KHANFIR",
    title: "Rym KHANFIR",
    isDirector: false,
    Biographie: [
      "Doctorat en Marketing",
      "Certification In Leadership And Management In Health: University Of Washington and Medicine University Of Tunis",
      "",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Séminaire métier",
      "Projet intégré",
      "Fondamentaux du marketing",
      "project Seminar",
      "Marketing research",
      "Consumer Behavior",
      "Marketing Case Study / Marketing Communication",
      "Distribution strategies",
    ],
    role: "Enseignante Marketing",
  },
  {
    img: ens4,
    link_title: "Marouane_RADDAOUI",
    title: "Marouane RADDAOUI",
    isDirector: false,
    Biographie: ["Mastère en informatique Multimédia et Décisionnelle"],
    Qualifications: [
      "Knowledge guided integration of structured and  unstructured data for health decision process.",
      "28th International Conference on Information Systems Development (ISD2019)",
    ],
    Domaines: [],
    Cours: [
      "Commerce électronique : projet wordpress",
      "Projet d'Intégration Multidisciplinaire (PIM)",
      "Initiation au langage python",
      "Modélisation multidimensionnelle et entrepôt de données",
      "Introduction au Big data et Cloud",
      "Développement mobile",
      "Web Mastering I",
      "Web Mastering II",
      "Culture et compétences numériques",
      "Réseaux",
      "C (PIM)",
      "ULM",
      "Java",
    ],
    role: "Enseignant Informatique",
  },

  {
    img: ens5,
    link_title: "Maroua_BEN_SLIMANE",
    title: "Maroua BEN SLIMANE",
    isDirector: false,
    Biographie: [
      "Doctorat en Électronique et Technologie de L’Information et de Communication",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Algorithmique et structures de données I",
      "Projet d'Intégration Multidisciplinaire (PIM)",
      "Algorithmique et structures de données II",
      "Compétences numériques",
      "Programmation web I",
      "Les fondamentaux de la sécurité IT",
      "Introduction aux bases de données web",
      "Initiation au développement web",
      "Atelier de programmation I",
      "Atelier de programmation C",
      "Système d'exploitation",
      "Réseaux",
      "Java",
    ],
    role: "Enseignante Informatique",
  },

  {
    img: ens6,
    link_title: "Salma_MAHWECHI",
    title: "Salma MAHWECHI",
    isDirector: false,
    Biographie: ["Doctorat en Marketing"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Projet intégré",
      "Séminaire métiers",
      "Communication marketing intégrée",
      "Nouvelles tendances de consommation et comportement du cyber consommateur",
      "Team building",
      "Fundamentals of marketing",
      "Event marketing",
      "Integrated project I",
      "Digital marketing  Business seminar",
      "Final year project Seminar",
      "Digital marketing",
    ],
    role: "Enseignante Marketing",
  },

  {
    img: ens7,
    link_title: "Mouna_SEDDIK",
    title: "Mouna SEDDIK",
    isDirector: false,
    Biographie: [
      "Master’s Degree in English Literature and Languages specialty Cross Cultural Poetics",
    ],
    Qualifications: [
      "Certificate of Participation in “The Body Considered Conference”",
      "Article : The Body as a Writer and the Body as a Narration Medium in D. H. Lawrence’s Fiction",
    ],
    Domaines: [],
    Cours: [
      "Business",
      "communication",
      "Business english II",
      "Business english III",
      "Business english IV",
      "Business english V",
      "Business english VI ",
    ],
    role: "Enseignante Anglais",
  },
  {
    img: ens8,
    link_title: "Kiser_KARI_LECIA",
    title: "Kiser KARI LECIA",
    isDirector: false,
    Biographie: [
      "Bachelor’s of Arts in English/Language Arts : Secondary Education",
    ],
    Qualifications: [
      "Participation à la Conférence mondiale du Baccalauréat international (IB), IBO, San Diego, Californie, États-Unis.",
      // "Langue et littérature du PPCS : dispenser le programme du PPCS Cat.",
      // "2 Certificat de formation, IBA Con/DP/MYP/PYP - Cat 1, 2, 3, Indianapolis, AUX ÉTATS-UNIS",
    ],
    Domaines: [],
    Cours: [
      "Business English I",
      "Business English V",
      "TOEIC III : préparation à la certification",
    ],
    role: "Enseignante Anglais",
  },

  {
    img: ens9,
    link_title: "Emille_MARTELLI",
    title: "Emille MARTELLI",
    isDirector: false,
    Biographie: ["TEFL Certificate (Teaching English as a Foreign Language)"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Business English I",
      "Business English II",
      "Business English III",
      "Business English IV",
    ],
    role: "Enseignante Anglais",
  },
  {
    img: ens10,
    link_title: "Maher_LAAROUSI",
    title: "Maher LAAROUSI",
    isDirector: false,
    Biographie: [
      "Doctorat en sciences et techniques des arts, Artiste plasticien",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Expression plastique et graphique",
      "Dessin I",
      "Dessin analytique I ",
      "Dessin analytique II",
    ],
    role: "Enseignant Design",
  },
  {
    img: ens11,
    link_title: "Tharouet_SAADI",
    title: "Tharouet SAADI",
    isDirector: false,
    Biographie: [
      "Doctorat en sciences et techniques des arts, Artiste plasticien",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Expression plastique",
      "Expression plastique et graphique",
      "Expression plastique et volumétrie II",
    ],
    role: "Enseignante Design",
  },

  {
    img: ens12,
    link_title: "Ilef_TRABELSI",
    title: "Ilef TRABELSI",
    isDirector: false,
    Biographie: [
      "Doctorat en sciences et techniques des arts",
      "Designer graphique",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "représentation I",
      "Illustration et techniques de représentation II",
      "Sémiotique de l'image II",
      "Design d'interface I",
      "Design d'interface II",
      "Compétences digitales I",
      "Compétences digitales II",
      "Sémiotique de l'image I",
    ],
    role: "Enseignante Design",
  },

  {
    img: ens13,
    link_title: "Adem_SAKLI",
    title: "Adem SAKLI",
    isDirector: false,
    Biographie: ["Architecte"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Perspective et dessin architectura",
      "Méthodologie du projet et programmation",
    ],
    role: "Enseignant Architecture",
  },
  {
    img: ens14,
    link_title: "Chedi_GDOURA",
    title: "Chedi GDOURA",
    isDirector: false,
    Biographie: ["Architecte, Doctorant en Technologies du Design"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Informatique appliquée",
      "Atelier D’architecture",
      "Atelier CAO/DAO",
    ],
    role: "Enseignant Architecture",
  },
  {
    img: ens15,
    link_title: "Emna_DAHMANI",
    title: "Emna DAHMANI",
    isDirector: false,
    Biographie: [
      "Architecte, Doctorante en Sciences et Ingénieries Architecturales.",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Théorie de l'architecture",
      "Gestion, organisation et éthique professionnelle",
      "Métré et pièces écrites",
      "Initiation à la méthodologie du projet",
      "Voyage d'études et projet d'application",
      "Analyse caractéristique de l'espace",
    ],
    role: "Enseignante Architecture",
  },
  {
    img: ens16,
    link_title: "Narimane_MESKINI",
    title: "Narimane MESKINI",
    isDirector: false,
    Biographie: [
      "Architecte, Doctorante en Sciences et Ingénieries Architecturales",
      "Certified Professionnal Revit For Architecture",
      "Certificate of Achievement TOIEC",
    ],
    Qualifications: [],
    Domaines: [],
    Cours: ["Méthodologie du projet et programmation"],
    role: "Enseignante Architecture",
  },
  {
    img: ens17,
    link_title: "Issam_BEN_MANSOUR",
    title: "Issam BEN MANSOUR",
    isDirector: false,
    Biographie: ["Architecte"],
    Qualifications: [],
    Domaines: [],
    Cours: ["Méthodologie du projet et programmation"],
    role: "Enseignante Architecture",
  },

  {
    img: ens18,
    title: "Hazar Daoud",
    link_title: "Hazar_Daoud",
    isDirector: false,
    Biographie: ["Doctorat en Comptabilité"],
    Qualifications: [],
    Domaines: [],
    Cours: [
      "Fiscalité IRPP/IS",
      "Etude de cas en comptabilité",
      "Contrôle de gestion Projet intégré",
      "Séminaire de méthodologie",
      "Séminaire métier",
    ],
    role: "Enseignante Comptabilité",
  },
];
